import { render, staticRenderFns } from "./LiquidUnclaimedDataDate.vue?vue&type=template&id=58f31db4&scoped=true&"
import script from "./LiquidUnclaimedDataDate.vue?vue&type=script&lang=js&"
export * from "./LiquidUnclaimedDataDate.vue?vue&type=script&lang=js&"
import style0 from "./LiquidUnclaimedDataDate.vue?vue&type=style&index=0&id=58f31db4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f31db4",
  null
  
)

export default component.exports